import get from 'lodash/get'
import {createSelector} from 'reselect'

// This file is mainly for components to display the state of API calls,
//  whether they be pending an API response or in some error state.

// Base
// ----------------------------------------------------------------------------

const accessors = (path) => {
  const data = (state) => get(state, `api.${path}.data`)
  const error = (state) => get(state, `api.${path}.error`)
  const status = (state) => get(state, `api.${path}.status`)

  return {
    data,
    error,
    hasError: createSelector(error, (e) => e instanceof Error),
    isFailure: createSelector(status, (x) => x === 'FAILURE'),
    isPending: createSelector(status, (x) => x === 'PENDING'),
    isSuccess: createSelector(status, (x) => x === 'SUCCESS'),
  }
}

// API
// ----------------------------------------------------------------------------

// Soonest Event Date

export const soonestEventDate = accessors('soonestEventDate')

// Login

export const login = accessors('login')

// Looks

export const looks = accessors('looks')

// Register

export const registration = accessors('registration')

// Participant Login & Registration

export const participant = accessors('participant')

// Reset Password

export const passwordReset = accessors('passwordReset')
